import React from "react";

const AuthSectionHeader = ({ title, description, className = "" }) => {
  return (
    <div className={`mb-8 ${className}`.trim()}>
      <h2 className="mb-3 text-[28px] font-semibold leading-tight tracking-[-0.03em] text-[#111111]">
        {title}
      </h2>
      <p className="text-[14px] leading-7 text-[#4b5563]">{description}</p>
    </div>
  );
};

export default AuthSectionHeader;
